export type SortOrder = 'asc' | 'desc';

export interface SortState {
  /** undefined = the API's own default order. */
  by: string | undefined;
  order: SortOrder;
}

/**
 * Columns that read best-first. "Which boats are best equipped?" is the question
 * the rating exists to answer, so the first click should answer it rather than
 * showing the worst-equipped boats in the market.
 */
const DESCENDING_FIRST = new Set(['equipmentScore']);

/** Click cycle for a column header: ascending → descending → unsorted. */
export function nextSort(current: SortState, column: string): SortState {
  const opensDescending = DESCENDING_FIRST.has(column);
  const first: SortOrder = opensDescending ? 'desc' : 'asc';
  const second: SortOrder = opensDescending ? 'asc' : 'desc';

  if (current.by !== column) return { by: column, order: first };
  if (current.order === first) return { by: column, order: second };
  return { by: undefined, order: 'asc' };
}
